import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import SRichTextViewer from '@/components/SRichTextViewer.vue';

export type SuggestionsCardSize = 'small' | 'default';

interface SuggestionsCardProps {
  icon?: string;
  label?: string;
  dismissHandler?: () => Promise<void>;
  addHandler?: () => Promise<void>;
  tooltipLabel?: string;
  disableDismiss?: boolean;
  disableAdd?: boolean;
  dismissButtonTooltip?: string;
  addButtonTooltip?: string;
  size?: SuggestionsCardSize;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Suggestions-Card',
  props: {
  icon: { default: '' },
  label: { default: '' },
  dismissHandler: { type: Function },
  addHandler: { type: Function },
  tooltipLabel: { default: '' },
  disableDismiss: { type: Boolean, default: false },
  disableAdd: { type: Boolean, default: false },
  dismissButtonTooltip: { default: '' },
  addButtonTooltip: { default: '' },
  size: { default: 'default' }
},
  setup(__props) {

const props = __props;


const iconSize = _computed(() => {
  if (props.size === 'small') return 'small';
  return 'default';
});

const fontSize = _computed(() => {
  if (props.size === 'small') return '12px';
  return '14px';
});

const iconMarginTop = _computed(() => {
  if (props.size === 'small') return '4px';
  return '0px';
});

return { __sfc: true,props, iconSize, fontSize, iconMarginTop, _computed, SRichTextViewer }
}

})